<template>
    <v-content>
        <v-layout justify-space-between px-6 py-4 style="background-color: white">
            <v-flex d-flex justify-start align-center ml-12>
                <v-layout xs12>
                    <v-flex shrink mr-3 style="text-align: center;">
                        <img alt="Vue logo" src="../../assets/logo.png" style="width: 80px;cursor: pointer;"
                            @click="$router.push('/').catch(err => { })">
                    </v-flex>
                    <v-flex shrink style="text-align: left;cursor: pointer;"
                        @click="$router.push('/').catch(err => { })">
                        <span style="color: #3E7662;font-size:16px;">สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย
                            กรมแพทย์ทหารบก</span><br>
                        <span style="color: #3E7662;font-size:22px;">Institutional Review Board</span><br>
                        <span style="color: #3E7662;font-size:16px;">Royal Thai Army Medical Department</span>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex shrink d-flex justify-end align-center mr-12>
                <!-- Login success -->
                <v-layout>
                    <v-flex mt-1 pr-3 d-flex justify-end align-center style="max-width: 62px;max-height: 50px;">
                        <img :src="imageUrl" alt="" width="100%" height="100%"
                            style="border-radius: 50px;object-fit: cover;">
                    </v-flex>
                    <v-flex pr-3 style="text-align: left;">
                        <v-layout>
                            <v-flex style="font-size: 14px">
                                <span style="color: #3E7662;font-weight: bold;font-size: 14px">ชื่อสมาชิก
                                </span>{{ user.thName }}
                                <v-menu offset-y bottom right id="menuFormHome">
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on">
                                            <v-icon style="color: #3E7662">arrow_drop_down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list id="menulistHome">
                                        <v-layout py-2 px-4 style="background-color: #E5E5E5; text-align: left">
                                            <v-flex>
                                                <span>ข้อมูลส่วนตัว</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-list-item-title class="menu-list-home"
                                            @click="$router.push('/edit-profile-user').catch(err => { })">
                                            <div
                                                style="border-bottom: 1px solid #E5E5E5; text-align: left;cursor: pointer;">
                                                <v-flex class="my-1 mx-4">
                                                    <v-icon class="mr-4">edit</v-icon>
                                                    <span style="font-size: 12px;">แก้ไขข้อมูล</span>
                                                </v-flex>
                                            </div>
                                        </v-list-item-title>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex style="font-size: 14px">
                                <span style="color: #3E7662;font-weight: bold">หน่วยงาน</span> {{
                                user ? user.affiliation ? user.affiliation.affiliation === 'อื่นๆ' ?
                                    user.otherAffiliation :
                                    user.affiliation.affiliation : '' : '' }}
                            </v-flex>
                        </v-layout>

                    </v-flex>
                    <v-flex d-flex justify-end align-center>
                        <v-btn color="#3E7662" dark @click="logout()">
                            ออกจากระบบ
                        </v-btn>
                    </v-flex>
                </v-layout>

                <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage">
                </loading>
            </v-flex>
        </v-layout>

    </v-content>
</template>

<script>
import Swal from 'sweetalert2';
import { mapState, mapActions } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "Header",
    components: {
        Loading
    },
    async created() {
        // this.check_login();
        await this.getUser();
        console.log('User:', this.user)
        this.imageUrl = this.user.pictureFilePath;
    },

    data: () => ({
        name: "Admin",
        organize: "กรมแพทย์ทหารบก",
        isLoading: false,
        fullPage: true,
        imageUrl: '',
    }),
    computed: {
        ...mapState({
            user: state => state.Auth.user
        })
    },
    methods: {
        ...mapActions('Auth', ['getUser']),
        check_login() {
            this.$store.dispatch('Auth/getUser')
                .then(data => {
                })
                .catch(err => {
                    Swal.fire({
                        title: 'กรุณาลงชื่อเข้าสู่ระบบ',
                        icon: "warning"
                    })
                    this.$router.push('/login');
                })
        },
        logout() {
            // this.isLoading = true;
            Swal.fire({
                title: 'คุณต้องการออกจากระบบหรือไม่?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3E7662',
                cancelButtonColor: 'rgb(189, 189, 189)',
                confirmButtonText: 'ออกจากระบบ',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    await Promise.all([
                        this.$store.dispatch('Auth/logout'),
                        this.$store.dispatch('Research/createState'),
                        this.$store.dispatch('User/createState'),
                        this.$store.dispatch('FormRF/createState'),
                    ]).then(() => {
                        this.$router.replace('/login');
                        this.isLoading = false;
                    })
                }
            })
        }
    },
}
</script>

<style lang="scss">
.theme--light.v-list#menulistHome {
    padding-top: 0;
    padding-bottom: 0;
}

.v-menu__content.theme--light.menuable__content__active#menuFormHome {
    left: unset !important;
}

.v-list-item#listItemHome {
    padding: 0px !important;
}

.menu-list-home:hover {
    background: rgba(224, 216, 209, 0.15);
}
</style>
